import type { Dispatch, SetStateAction } from 'react'
import { useCallback, useEffect, useState } from 'react'

import { SEARCH_DEBOUNCE_MS } from '../search-modal.const'

export function useDebouncedSearchQuery(): {
  debouncedQuery: string
  query: string
  setDebouncedImmediately: (next: string) => void
  setQuery: Dispatch<SetStateAction<string>>
} {
  const [query, setQuery] = useState('')
  const [debouncedQuery, setDebouncedQuery] = useState('')

  useEffect(() => {
    const t = window.setTimeout(() => {
      setDebouncedQuery(query.trim())
    }, SEARCH_DEBOUNCE_MS)

    return () => window.clearTimeout(t)
  }, [query])

  const setDebouncedImmediately = useCallback((next: string) => {
    setDebouncedQuery(next.trim())
  }, [])

  return { debouncedQuery, query, setDebouncedImmediately, setQuery }
}
